import { State, Selector, Action, StateContext, createSelector } from '@ngxs/store';
import { AuthStateModel, Login, Logout, RefreshToken } from '../models/auth.model';
import { Injectable } from '@angular/core';
import {KeycloakService} from "keycloak-angular";
import { clearKeycloakLoginRedirect, keycloakLogin } from '../services/common/keycloak-login-redirect';
@State<AuthStateModel>({
    name: 'auth'
})
@Injectable()
export class AuthState {
    @Selector()
    static getAuthenticated(state: AuthStateModel) {
        return state.authenticated;
    }

    @Selector()
    static getUser(state: AuthStateModel) {
        return state.username;
    }

    @Selector()
    static token(state: AuthStateModel) { return state.token; }

    static expiresIn(timeout: number) {
        return createSelector([AuthStateModel], state => {
            return state.expires_at - new Date().getTime() < timeout;
        });
    }

    constructor(private keycloakService: KeycloakService) { }

    @Action(Login)
    login({ patchState }: StateContext<AuthStateModel>, { payload }: Login) {
        clearKeycloakLoginRedirect();
        patchState({...payload});
    }

    @Action(Logout)
    logout({ setState }: StateContext<AuthStateModel>) {
      clearKeycloakLoginRedirect();
      setState({
        authenticated: false,
        username: null,
        token: null,
        expires_at: null,
      });
      this.keycloakService.logout();
    }

    @Action(RefreshToken)
    refresh({ patchState }: StateContext<AuthStateModel>) {
        return this.keycloakService.updateToken(60).then(res => {
          const keycloak = this.keycloakService.getKeycloakInstance();
          const token = keycloak.token;
          const expires_at = keycloak.tokenParsed?.exp ? keycloak.tokenParsed.exp * 1000 : null;
          const refresh_token = keycloak.refreshToken;

          if (!token || !expires_at) {
            throw new Error('Token is null or expired');
          }

          patchState({ token, refresh_token, expires_at });
        }).catch(error => {
          console.log("Error refreshing token:", error);
          void keycloakLogin(this.keycloakService);
          throw error;
        });
    }

}
